"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidClaim = exports.stringAsBool = exports.normalizeString = exports.customBoolDict = void 0;
const claims_1 = require("./claims");
const defaultStringToBooleanMap = {
    sim: true,
    yes: true,
    true: true,
    verdadeiro: true,
    nao: false,
    no: false,
    false: false,
    falso: false,
};
exports.customBoolDict = {
    ...defaultStringToBooleanMap,
    '1': true,
    s: true,
    y: true,
    '0': false,
    n: false,
};
const normalizeString = (value) => {
    if (!value)
        return '';
    return value
        ?.trim()
        .toString()
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
};
exports.normalizeString = normalizeString;
const stringAsBool = (value, dictOnly = true, normalize = true, dictionary = defaultStringToBooleanMap) => {
    if (typeof value === 'boolean')
        return value;
    const normalizedValue = normalize ? (0, exports.normalizeString)(value) : value;
    const dictTry = dictionary[normalizedValue];
    const dictOnlyCheck = dictOnly ? false : Boolean(normalizedValue);
    // if dictOnly, returns true only if it exists on the dictionary, else it parses to bool
    return dictTry != null ? dictTry : dictOnlyCheck;
};
exports.stringAsBool = stringAsBool;
function isValidClaim(str) {
    return Object.values(claims_1.UsersClaims).indexOf(str) !== -1;
}
exports.isValidClaim = isValidClaim;
